module.exports = "/remote-dist/57bffa64b1768b1e1aef61df50cbaf3f.jpg";